// Pagina de Banners — orquestracao com duas abas.
//   Cardápio: imagens de destaque no topo do cardapio publico (web e mobile).
//   Totem:    fotos/videos em loop atras do "Faca seu pedido" do totem (ate 5).
// Mesma tabela e mesma mecanica (ordem, pausar, remover); muda o upload
// (totem aceita video e nao recorta) e o lugar onde aparece.

import { Images } from "lucide-react";
import { useState } from "react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import CardapioBannersTab from "./CardapioBannersTab";
import TotemBannersCardapioTab from "./TotemBannersCardapioTab";
import TotemMidiasTab from "./TotemMidiasTab";

export default function BannersPage() {
  const [aba, setAba] = useState("cardapio");
  // Totem tem duas sub-abas: "Tela inicial" (mídias da tela de descanso) e
  // "Cardápio de produtos" (banner largo no topo do cardápio do totem).
  const [subTotem, setSubTotem] = useState("inicial");

  return (
    <div className="max-w-3xl mx-auto p-4 md:p-6 lg:p-8 space-y-6">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-sm">
          <Images className="w-6 h-6 text-primary-foreground" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Banners</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            {aba === "totem"
              ? (subTotem === "cardapio" ? "Banners largos no topo do cardápio do totem" : "Fotos e vídeos que passam na tela de descanso do totem")
              : "Imagens de destaque no topo do cardápio, no site e no celular"}
          </p>
        </div>
      </div>

      <Tabs value={aba} onValueChange={setAba} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="cardapio" data-e2e="tab-banner-cardapio">Cardápio</TabsTrigger>
          <TabsTrigger value="totem" data-e2e="tab-banner-totem">Totem</TabsTrigger>
        </TabsList>
        <TabsContent value="cardapio" className="mt-6">
          <CardapioBannersTab />
        </TabsContent>
        <TabsContent value="totem" className="mt-6">
          <Tabs value={subTotem} onValueChange={setSubTotem} className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6">
              <TabsTrigger value="inicial" data-e2e="subtab-totem-inicial">Tela inicial</TabsTrigger>
              <TabsTrigger value="cardapio" data-e2e="subtab-totem-cardapio">Cardápio de produtos</TabsTrigger>
            </TabsList>
            <TabsContent value="inicial"><TotemMidiasTab /></TabsContent>
            <TabsContent value="cardapio"><TotemBannersCardapioTab /></TabsContent>
          </Tabs>
        </TabsContent>
      </Tabs>
    </div>
  );
}
